(function () {
  var outer = document.querySelector('.halo-scale-outer');
  var root = document.querySelector('.halo-scale-root');
  if (!outer || !root) return;

  function updateHaloScale() {
    var w = window.innerWidth;
    // 20/10/2026: the photos + buy box section undoes this zoom (halo-scale.css), so keep its factor in step.
    document.documentElement.style.setProperty('--halo-unscale', w > 1728 ? String(1728 / w) : '1');
    // 21/10/2026: Infra Pod scales with CSS zoom (halo-scale.css) so its pinned photos + buy box keep working.
    document.documentElement.style.setProperty('--halo-zoom', w > 1728 ? String(w / 1728) : '1');
    if (w < 1729 || document.body.classList.contains('template-infra-pod')) {
      root.style.transform = '';
      outer.style.height = '';
      return;
    }
    var scale = w / 1728;
    root.style.transform = 'scale(' + scale + ')';
    outer.style.height = (root.offsetHeight * scale) + 'px';
  }

  updateHaloScale();
  window.addEventListener('resize', updateHaloScale);
  window.addEventListener('load', updateHaloScale);
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(updateHaloScale).observe(root);
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHaloScale);
  }
})();
